<div *ngIf="entity" class="form-horizontal">
    <div class="col-md-7">
        <div class="form-group">
            <edit-prop isChild label="Prediction Name" prop="comment" szs="2,5">
                <input class="form-control" type="text" [(ngModel)]="entity.predictionName">
            </edit-prop>
        </div>

        <div class="form-group">
            <edit-prop isChild label="Primary Judgement" prop="enabled" szs="2,5">
                <input class="form-control" type="checkbox" [(ngModel)]="entity.primaryJudgment">
            </edit-prop>
        </div>
    </div>
</div>
